import { FINDING_METHOD_AGGREGATE, setFindingMethod } from '@src/telemetry/findingMethod'

import CUSTOM_SECTION_CONTAINER_NAMES from '../../../../constants/customSectionContainerNames'

export const setCustomSectionFindingMethods = (
  tracker?: string,
  tracking_id?: string,
  content_container_name?: CUSTOM_SECTION_CONTAINER_NAMES,
) => {
  switch (tracker) {
    case 'home_page':
      setFindingMethod[FINDING_METHOD_AGGREGATE.CAMPAIGN]?.({
        elementName: content_container_name ?? '',
        elementId: tracking_id ?? '',
      })
      break
    default:
      break
  }
}
